/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createPti } from '../fn/pti-controller/create-pti';
import { CreatePti$Params } from '../fn/pti-controller/create-pti';
import { CreatePtiResponse } from '../models/create-pti-response';

@Injectable({ providedIn: 'root' })
export class PtiControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createPti()` */
  static readonly CreatePtiPath = '/v2/pti/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPti()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPti$Response(
    params: CreatePti$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<CreatePtiResponse>> {
    return createPti(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPti$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPti(params: CreatePti$Params, context?: HttpContext): Observable<CreatePtiResponse> {
    return this.createPti$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreatePtiResponse>): CreatePtiResponse => r.body)
    );
  }
}
